module.exports = {
	locale: 'en',
	long: require('./long.json'),
	short: require('./short.json'),
	narrow: require('./narrow.json'),
	quantify: require('./quantify')
}